import React from "react";
import keylogo from "../../../images/keylogo.png";
import Image3 from "../../../images/Image3.jpeg";
import SplitStorySection from "../../ui/SplitStorySection";
import ProseSection from "../../ui/ProseSection";
import FadeIn from "../../ui/FadeIn";

const ASection2 = () => (
  <>
    <ProseSection highlight className="!py-12">
      <FadeIn>
        <h2 className="ku-heading-lg text-center mb-8">
          KU strongly believes that kindness was never about being selfless to the point of eventually becoming selfish.
        </h2>
        <div className="flex justify-center">
          <img className="max-w-md w-full rounded-ku-lg shadow-card" src={Image3} alt="Kindness key" />
        </div>
      </FadeIn>
    </ProseSection>
    <SplitStorySection image={keylogo} imageAlt="Kindness Unlimited key logo">
      <p>
        Replenishing one&apos;s cup to the brim first so as to be able to fill others&apos; cups is, in fact, the correct approach towards &apos;being kind&apos;.
        <br />
        After all, being kind to oneself is perhaps, the first step in the journey of kindness.
      </p>
      <p>
        As a Guidestar Certified NGO & the only NGO to represent India at the &apos;World Kindness Movement&apos;- <br />
        KU uses the power of collaboration, youth & volunteerism to unify & eventually transform India into KINDia by having people initiate perpetual acts of kindness.
      </p>
    </SplitStorySection>
  </>
);

export default ASection2;
